import { updateParkingServiceParkingSpaces } from '../../api/parking-service.ts';
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { UpdateParkingServiceParkingSpacesRequest } from '../../api/requests/parking-service-request.ts';

export default function useUpdateParkingServiceParkingSpaces(): UseMutationResult<
  Awaited<ReturnType<typeof updateParkingServiceParkingSpaces>>,
  Error,
  UpdateParkingServiceParkingSpacesRequest
> {
  return useMutation({
    mutationFn: updateParkingServiceParkingSpaces,
  });
}
